var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSeat = function SvgSeat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.50606 2.08C7.27613 1.53713 6.89135 1.07404 6.39977 0.748571C5.90819 0.423105 5.33161 0.249695 4.74206 0.25H2.29206C2.0873 0.251504 1.88501 0.294747 1.69753 0.377084C1.51005 0.459422 1.34134 0.579126 1.20169 0.728879C1.06205 0.878633 0.954407 1.05529 0.885351 1.24805C0.816294 1.44082 0.787272 1.64564 0.800058 1.85L2.00006 19.95C2.05087 20.7105 2.38923 21.4231 2.94643 21.9432C3.50363 22.4632 4.23788 22.7517 5.00006 22.75H18.6471C19.3061 22.7513 19.9472 22.5356 20.4713 22.1361C20.9955 21.7367 21.3735 21.1758 21.5471 20.54L21.9611 19.019C22.0935 18.5336 22.1018 18.0226 21.985 17.5332C21.8683 17.0437 21.6303 16.5915 21.2929 16.2181C20.9556 15.8448 20.5298 15.5622 20.0547 15.3965C19.5796 15.2309 19.0704 15.1873 18.5741 15.27L9.69406 16.75C10.2541 11.7529 9.4999 6.69618 7.50606 2.08V2.08Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_31"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
export default SvgSeat;